var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosePoi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.395,
    height: 14.897,
    viewBox: "0 0 14.395 14.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#002c52;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-303.803 -40.618)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.803 40.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M86.474,7.453,91.123,2.8a1.177,1.177,0,0,0,.354-.866,1.177,1.177,0,0,0-.354-.866L90.406.354a1.236,1.236,0,0,0-1.732,0L82.437,6.582a1.236,1.236,0,0,0,0,1.732l6.237,6.228a1.236,1.236,0,0,0,1.732,0l.717-.717a1.171,1.171,0,0,0,.354-.861,1.2,1.2,0,0,0-.354-.87Z",
    transform: "translate(-82.083 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.197 55.514) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M86.474,7.453,91.123,2.8a1.177,1.177,0,0,0,.354-.866,1.177,1.177,0,0,0-.354-.866L90.406.354a1.236,1.236,0,0,0-1.732,0L82.437,6.582a1.236,1.236,0,0,0,0,1.732l6.237,6.228a1.236,1.236,0,0,0,1.732,0l.717-.717a1.171,1.171,0,0,0,.354-.861,1.2,1.2,0,0,0-.354-.87Z",
    transform: "translate(-82.083 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePoi);
export default __webpack_public_path__ + "static/media/close-poi.73e492277a194788e9394298f93f14ef.svg";
export { ForwardRef as ReactComponent };